module.exports = __webpack_public_path__ + "static/media/shapes_22.86cd3d9f.svg";